import ErrorSerializer from '../ErrorSerializerClass'

export default new ErrorSerializer()
